module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("III")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hat is this breeze on my face?")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("What are these scents, the flowers and the sea?")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("What does springtime want from me, why doesn’t it go back where it came from?")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I’m a dead man, don’t you understand that, springtime? I’m a dead man.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I’ve been dead for years and years, even though I breathed, worked, ate, and slept. I talked to the people I met, and maybe to be polite I even laughed, pretended to be interested: but I was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("If your heart doesn’t beat in your chest, then you’re dead. And my heart wasn’t beating. Not anymore. ")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("It’s better to be born blind. You can’t remember colors if you’ve never seen them before. If you’re born blind, then the sun is nothing more than warmth on your skin and the sea is just water on your feet; you can’t imagine how the light shimmers against the blue, while clouds scud across the sky, creating and erasing shadows. It’s better, if you’re born blind.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("But if you’ve seen the light and then they take it away from you, all you can do is remember. You just remember, you don’t live anymore: you’re dead.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Curse you, God, why did you force me to be reborn? Why did you give back the sight that you took away from me, and the hope that I’d long since forgotten? God, you coward, why did you make me breathe again, and laugh again, and make my heart beat again, wasn’t the suffering you’d already inflicted on me enough? Did you know that you would kill me a second time? You know everything, so why? Damn you to hell: you sent me to the inferno, you pulled me back out, and in the end you locked me in there forever.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Leaving my soul trapped in a bedroom at Il Paradiso. Motionless, breathless, awaiting a word that will never come from her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("From her dead mouth.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e07687a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viper_00004.vue
// module id = 78
// module chunks = 0